import type { SelfSharedDrivesResponseDatagramBuf } from "~/classes/generated/response"
import type { File } from "~/models/polyschema/File"

import { DatagramBuf } from "~/classes/generated/datagram"
import { RequestDatagramBuf, SelfSharedDrivesRequestDatagramBuf } from "~/classes/generated/request"
import { DatagramBufferBuilder } from "~/utils/flatbuffers/builder"
import { addRequestIdToBuf, parseDatagramError, parseRequestId } from "~/utils/flatbuffers/datagram"
import { parseSelfSharedDrive } from "~/utils/flatbuffers/user"
import { maybe } from "~/utils/helpers"

const console = useLogger("user/info", theme.colors.pink.hex)

export function sendSelfSharedDrivesRequest(request: SelfSharedDrivesRequestDatagram) {
  const { sendWorkerDatagramBuf } = useCache()

  const builder = new DatagramBufferBuilder(64)
  const requestId = addRequestIdToBuf(builder, request.requestId)
  SelfSharedDrivesRequestDatagramBuf.startSelfSharedDrivesRequestDatagramBuf(builder)
  SelfSharedDrivesRequestDatagramBuf.addRequestId(builder, requestId)
  SelfSharedDrivesRequestDatagramBuf.addOffline(builder, request.offline)
  const infoRequest = SelfSharedDrivesRequestDatagramBuf.endSelfSharedDrivesRequestDatagramBuf(builder)

  RequestDatagramBuf.startRequestDatagramBuf(builder)
  RequestDatagramBuf.addSelfSharedDrivesRequest(builder, infoRequest)
  const requests = DatagramBuf.createRequestVector(builder, [RequestDatagramBuf.endRequestDatagramBuf(builder)])
  DatagramBuf.startDatagramBuf(builder)
  DatagramBuf.addRequest(builder, requests)
  builder.finish(DatagramBuf.endDatagramBuf(builder))
  sendWorkerDatagramBuf(builder.asUint8Array())
}

export function handleSelfSharedDrivesResponseDatagramBuf(datagram: SelfSharedDrivesResponseDatagramBuf) {
  const sharedDrives: Record<string, [File, File]> = {}
  for (const i of range(datagram.sharedDrivesLength())) {
    const { sharedDriveId, home, archive } = parseSelfSharedDrive(datagram.sharedDrives(i)!)
    sharedDrives[sharedDriveId] = [home, archive]
  }

  onSelfSharedDrivesResponseDatagram({
    requestId: parseRequestId(datagram.requestId()!),
    offline: datagram.offline(),
    error: maybe(parseDatagramError)(datagram.error()),
    sharedDrives,
  })
}

export function onSelfSharedDrivesResponseDatagram(response: SelfSharedDrivesResponseDatagram) {
  const { emitInterfaceEvent, emitEntityEvent } = useEvents()
  emitInterfaceEvent("selfSharedDrivesResponse", response, response.requestId)

  if (response.error || response.sharedDrives === undefined)
    return console.error("Shared drives info request failed", response)

  for (const roots of Object.values(response.sharedDrives)) {
    const [home, archive] = roots!
    emitEntityEvent("fileProperties", home.id, home, response.offline)
    emitEntityEvent("fileProperties", archive.id, archive, response.offline)
  }
}
